import Crypto from 'crypto-js';
import Cookie from 'js-cookie';
import uuid from 'uuid';


const cookieName = 'bo-cookie';

// Get the encryption token from cookie or generate a new one.
const encryptionToken = Cookie.get(cookieName) || uuid?.v4();

// Store the encryption token in a secure cookie.
Cookie.set(cookieName, encryptionToken, { secure: true, expires: 180 });

export default class CookieStorage implements Storage {
    [name: string]: any;
    length = 0;
    clear(): void {
        this.length = 0;
        window.localStorage.clear();
    }
    key(index: number): string | null {
        return window.localStorage.key(index);
    }

    getItem(key: string): any {
        const store = window.localStorage.getItem(key);

        if (store) {
            try {
                // Decrypt the store retrieved from local storage
                // using our encryption token stored in cookies.
               //const bytes = Crypto.AES.decrypt(store, encryptionToken);

                return JSON.parse(store);
            } catch (e) {
                // The store will be reset if decryption fails.
                window.localStorage.removeItem(key);
            }
        }

        return null;
    }
    removeItem(key: string): void {
        this.setItem(key, '');
    }
    setItem(key: string, data: string): void {
        if (data != null) {
            try{
            // Encrypt the store using our encryption token stored in cookies.
          //  const store = Crypto.AES.encrypt(data, encryptionToken).toString();

            // Save the encrypted store in local storage.
            return window.localStorage.setItem(key, data);
            }
             catch (ex){
                console.log(ex);
             }
        }
    }
}